<template>
  <v-card class="filter-menu-card-container px-0">
    <v-card-title class="pa-0">
      <v-row>
        <v-col class="py-4" cols="3">
          <v-btn v-if="showClearBtn && clearBtn" class="header-btn" :min-width="66" :height="40" color="orange50" variant="text" @click="doClearData">
            {{ $t('all_clear') }}
          </v-btn>
        </v-col>

        <v-col class="py-4" cols="6">
          <p class="dialog-title text-center mb-0">{{ title }}</p>
        </v-col>

        <v-col class="py-4 text-right" cols="3">
          <v-btn class="header-btn mr-5" :min-width="24" :width="24" :height="24" variant="text" @click="doClosed">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>

    <PriceRange
      v-if="contentType === 'range-bar'"
      :value="filterValue"
      :is-clear="clearing"
      :key-value="keyValue"
      :options="filterOptions"
      :currency="currency"
      @update-clear-btn="updateClearBtn"
      @return-filter="setSelectedFilter"
    />

    <RadioFilter
      v-if="contentType === 'list'"
      :value="filterValue"
      :key-value="keyValue"
      :options="filterOptions"
      @update-clear-btn="updateClearBtn"
      @return-filter="setSelectedFilter"
    />

    <DatePicker
      v-if="contentType === 'date-picker'"
      :value="filterValue"
      :is-clear="clearing"
      :key-value="keyValue"
      :day-mode="dateMode"
      :options="filterOptions"
      @update-clear-btn="updateClearBtn"
      @return-filter="setSelectedFilter"
    />

    <TimePicker
      v-if="contentType === 'time-picker'"
      :value="filterValue"
      :is-clear="clearing"
      :selected-date="selectedDate"
      @update-clear-btn="updateClearBtn"
      @return-filter="setSelectedFilter"
    />

    <CheckBoxFilter
      v-if="contentType === 'check-box'"
      :value="filterValue"
      :is-clear="clearing"
      :key-value="keyValue"
      :options="filterOptions"
      @update-clear-btn="updateClearBtn"
      @return-filter="setSelectedFilter"
    />

    <v-card-actions class="py-6 px-5 justify-end">
      <v-btn class="large--btn" height="40" color="orange50" variant="flat" block @click="doConfirm">
        <loading v-if="filterLoading" />
        <span v-else-if="type === 'chips' || type === 'tags'"> {{ filterResultText }} </span>
        <span v-else> {{ $t('all_ok') }} </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import filterActions from '@/composition/filter-actions'

import Loading from '@/components/icons/loading.vue'
import PriceRange from '@/components/page/categories/price-range.vue'
import DatePicker from '@/components/page/categories/date-picker.vue'
import RadioFilter from '@/components/page/categories/mobile/radio-filter.vue'
import CheckBoxFilter from '@/components/page/categories/check-box-filter.vue'
import TimePicker from '@/components/page/categories/time-picker.vue'

export default {
  name: 'FilterContextCard',
  components: {
    Loading,
    PriceRange,
    DatePicker,
    RadioFilter,
    CheckBoxFilter,
    TimePicker,
  },
  props: {
    currency: { type: String, default: '' },
    clearBtn: { type: Boolean, default: false },
    sort: { type: String, default: '' },
    index: { type: Number, default: 0 },
    title: { type: String, default: '' },
    contentType: { type: String, default: '' },
    filterKey: { type: String, default: '' },
    filterValue: { type: [String, Number, Object, Array], default: '' },
    filterOptions: { type: Array, default: () => [] },
    currentFilter: { type: Object, default: () => ({}) },
    currentTagFilter: { type: Object, default: () => ({}) },
    dateMode: { type: Number, default: 1 },
    totalCount: { type: Number, default: 0 },
    isDebounce: { type: Boolean, default: true },
    type: { type: String, default: '' },
    filterParams: { type: Object, default: () => ({}) },
    filterSelected: { type: Boolean, default: false },
    keyValue: { type: Array, default: () => [] },
    isBranchCardMode: { type: Boolean, default: true },
  },
  emits: ['confirm', 'close'],
  setup(props) {
    const {
      showClearBtn,
      clearing,
      filterLoading,
      filterTotalCount,
      setSelectedFilter,
      fetchTempFilterData,
      doClearData,
      getConfirmFilterData,
      updateClearBtn,
    } = filterActions(props)

    const selectedDate = computed(() => props.currentFilter?.starttime || '')

    return {
      selectedDate,
      showClearBtn,
      clearing,
      filterLoading,
      filterTotalCount,
      setSelectedFilter,
      fetchTempFilterData,
      doClearData,
      updateClearBtn,
      getConfirmFilterData,
    }
  },
  data() {
    return {}
  },
  computed: {
    filterResultText() {
      return this.filterTotalCount <= 100
        ? this.$t('filter_result_exact_button', { result: this.filterTotalCount })
        : this.$t('filter_result_exceed_button', { result: 100 })
    },
  },
  methods: {
    doConfirm() {
      const filterResponse = this.getConfirmFilterData()
      this.$emit('confirm', filterResponse)
      this.doClosed()
    },
    doClosed() {
      this.doClearData()
      this.$emit('close', { type: this.type, index: this.index })
    },
  },
}
</script>
<style lang="scss" scoped>
.filter-menu-card-container {
  border-radius: 0 !important;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}

.dialog-title,
.header-btn {
  line-height: 40px;
  font-size: 17px;
}

.header-btn {
  font-weight: normal;
}
</style>
